module.exports = __webpack_public_path__ + "65c2d281ab558f3ab538204401a70ff6.svg";